import { commonjsGlobal as a } from "./index168.js";
import { __exports as f } from "./index177.js";
import "./index190.js";
import "./index191.js";
import { __exports as p } from "./index192.js";
import { __exports as m } from "./index193.js";
(function(r) {
  var c = a && a.__createBinding || (Object.create ? function(o, t, e, n) {
    n === void 0 && (n = e);
    var i = Object.getOwnPropertyDescriptor(t, e);
    (!i || ("get" in i ? !t.__esModule : i.writable || i.configurable)) && (i = { enumerable: !0, get: function() {
      return t[e];
    } }), Object.defineProperty(o, n, i);
  } : function(o, t, e, n) {
    n === void 0 && (n = e), o[n] = t[e];
  }), u = a && a.__exportStar || function(o, t) {
    for (var e in o)
      e !== "default" && !Object.prototype.hasOwnProperty.call(t, e) && c(t, o, e);
  };
  Object.defineProperty(r, "__esModule", { value: !0 }), r.DomHandler = void 0;
  var d = m, s = p;
  u(p, r);
  var l = {
    withStartIndices: !1,
    withEndIndices: !1,
    xmlMode: !1
  }, h = (
    /** @class */
    function() {
      function o(t, e, n) {
        this.dom = [], this.root = new s.Document(this.dom), this.done = !1, this.tagStack = [this.root], this.lastNode = null, this.parser = null, typeof e == "function" && (n = e, e = l), typeof t == "object" && (e = t, t = void 0), this.callback = t ?? null, this.options = e ?? l, this.elementCB = n ?? null;
      }
      return o.prototype.onparserinit = function(t) {
        this.parser = t;
      }, o.prototype.onreset = function() {
        this.dom = [], this.root = new s.Document(this.dom), this.done = !1, this.tagStack = [this.root], this.lastNode = null, this.parser = null;
      }, o.prototype.onend = function() {
        this.done || (this.done = !0, this.parser = null, this.handleCallback(null));
      }, o.prototype.onerror = function(t) {
        this.handleCallback(t);
      }, o.prototype.onclosetag = function() {
        this.lastNode = null;
        var t = this.tagStack.pop();
        this.options.withEndIndices && (t.endIndex = this.parser.endIndex), this.elementCB && this.elementCB(t);
      }, o.prototype.onopentag = function(t, e) {
        var n = this.options.xmlMode ? d.ElementType.Tag : void 0, i = new s.Element(t, e, void 0, n);
        this.addNode(i), this.tagStack.push(i);
      }, o.prototype.ontext = function(t) {
        var e = this.lastNode;
        if (e && e.type === d.ElementType.Text)
          e.data += t, this.options.withEndIndices && (e.endIndex = this.parser.endIndex);
        else {
          var n = new s.Text(t);
          this.addNode(n), this.lastNode = n;
        }
      }, o.prototype.oncomment = function(t) {
        if (this.lastNode && this.lastNode.type === d.ElementType.Comment) {
          this.lastNode.data += t;
          return;
        }
        var e = new s.Comment(t);
        this.addNode(e), this.lastNode = e;
      }, o.prototype.oncommentend = function() {
        this.lastNode = null;
      }, o.prototype.oncdatastart = function() {
        var t = new s.Text(""), e = new s.CDATA([t]);
        this.addNode(e), t.parent = e, this.lastNode = t;
      }, o.prototype.oncdataend = function() {
        this.lastNode = null;
      }, o.prototype.onprocessinginstruction = function(t, e) {
        var n = new s.ProcessingInstruction(t, e);
        this.addNode(n);
      }, o.prototype.handleCallback = function(t) {
        if (typeof this.callback == "function")
          this.callback(t, this.dom);
        else if (t)
          throw t;
      }, o.prototype.addNode = function(t) {
        var e = this.tagStack[this.tagStack.length - 1], n = e.children[e.children.length - 1];
        this.options.withStartIndices && (t.startIndex = this.parser.startIndex), this.options.withEndIndices && (t.endIndex = this.parser.endIndex), e.children.push(t), n && (t.prev = n, n.next = t), t.parent = e, this.lastNode = null;
      }, o;
    }()
  );
  r.DomHandler = h, r.default = h;
})(f);
